var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.style)},[(_vm.dialog.multiple)?_c('Tree',{ref:"tree",attrs:{"data":_vm.treeData,"load-data":_vm.loadData,"show-checkbox":"","check-strictly":true},on:{"on-check-change":_vm.checkChange}}):_c('Tree',{ref:"tree",attrs:{"data":_vm.treeData,"load-data":_vm.loadData},on:{"on-select-change":_vm.selectChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }